import {
  getRecordingSources,
  getExternalSources,
  getInternalSources,
  getSourceOptions,
  getVideoSourceNames,
  VIDEO_SOURCE_TYPES,
} from './sourceOptions';
import { FOOTBALL_IDENTIFIER } from '../Sport/Sport';

/**
 * Legacy external source names.
 * These are not selectable in the video source name dropdown,
 * but can still be viewed in the SourceData table component to maintain backwards compatibility.
 */
export const getLegacyExternalSources = (intl) => [
  {
    isLegacySourceName: true,
    label: intl.formatMessage({
      defaultMessage: 'Football Data Co',
      id: '620d7',
    }),
    sport: FOOTBALL_IDENTIFIER,
    value: {
      id: 'FOOTBALL_DATA_CO',
      isLicensed: false,
    },
  },
];

export const getAllSourceDisplayOptions = (intl) => [
  ...getRecordingSources(intl),
  ...getExternalSources(intl),
  ...getInternalSources(intl),
  ...getLegacyExternalSources(intl),
];

export const getAllSourceTypeDisplayOptions = (intl) => [
  ...getSourceOptions(intl),
  {
    isLegacy: true,
    label: intl.formatMessage({
      defaultMessage: 'Internal Provider',
      id: 'db6d2',
    }),
    value: {
      sourceNames: getVideoSourceNames(intl).INTERNAL,
      sourceType: VIDEO_SOURCE_TYPES.INTERNAL_PROVIDER,
    },
  },
];

/**
 * Find the display label for a given sourceType
 */
export const getDisplayLabelFromSourceType = (intl, sourceType) =>
  getAllSourceTypeDisplayOptions(intl).find(
    (option) => option.value.sourceType === sourceType,
  )?.label;

/**
 * Find the display label for a given sourceName
 */
export const getDisplayLabelFromSourceName = (intl, sourceName) =>
  getAllSourceDisplayOptions(intl).find(
    (option) => option.value.id === sourceName,
  )?.label;
